import React from 'react';
import spotlight from "../../images/spotlight.png"
import image1 from "../../images/datawithSS.png"
import image2 from "../../images/sus3.png"
import image3 from "../../images/traffic.png"
import image4 from "../../images/sus1.png"
import image6 from "../../images/TimiAndChuka.png"
import imgage7 from "../../images/image 139.png"
import image8 from "../../images/Netzence.png"
import imgage9 from "../../images/SSwithAxeela.png"
const ArticleCard = ({ image, category, categoryColor, title, description, source, readMoreLink }) => {
  return (
    <div className="flex mb-20 flex-col items-center p-0 pb-6 gap-4  h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl">
      {/* Article Image */}
      <img 
        src={image} 
        alt={title}
        className="w-[378px] h-[282px] object-fill  rounded-t-2xl "
      />
      
      {/* Article Content */}
      <div className="flex flex-col items-start p-0 gap-4 w-[352px] h-[222px]">
        {/* Category Tag */}
        <div 
          className="flex flex-row justify-center items-center py-0.5 px-1.5 gap-2.5 h-[25px] rounded"
          style={{ backgroundColor: categoryColor, borderRadius: '4px' }}
        >
          <span className=" font-medium text-[14px] leading-[21px] text-white">
            {category}
          </span>
        </div>
        
        {/* Text Container */}
        <div className="flex flex-col items-start p-0 gap-3 w-[352px] h-[144px]">
          {/* Title */}
          <h3 className=" font-semibold text-[20px] leading-[120%] tracking-[-0.02em] text-[#3B3B3B] w-[352px] line-clamp-2">
            {title}
          </h3>
          
          {/* Description */}
          <p className=" font-normal text-[14px] leading-[145%] text-[#898989] w-[352px] line-clamp-3">
            {description}
          </p>
        </div>
        
        {/* Article Footer */}
        <div className="flex flex-row justify-between items-center p-0 gap-[150px] w-[352px] h-[21px]">
          <span className=" font-normal text-[14px] leading-[21px] text-[#3B3B3B]">
            {source}
          </span>
          
          {/* Read More Link */}
          <a 
            href={readMoreLink} 
            className="flex flex-row justify-center items-center p-0 gap-2 w-[99px] leading-[21px] h-5 group"
          >
            <span className=" font-medium text-[14px] text-[#006633]">
              Read More
            </span>
            <div className="w-5 h-[18px] relative">
              <svg 
                className="absolute w-2 h-3 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                viewBox="0 0 9 18" 
                fill="none"
              >
                <path
                  d="M1 1L8 9L1 17"
                  stroke="#006633"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

// Main Blog Grid Component
const BlogGrid = () => {
  const articles = [
    // Row 1
    {
      image: image1,
      category: "Clean Transport",
      categoryColor: "#006633",
      title: "Netzence set to unveil clean mobility hailing App in June 2026",
      description: "At a time when Nigeria’s cities are expanding at an unprecedented pace, and the strain on urban systems is becoming increasingly visible, e, a quiet but critical shift is beginning to take shape...",
      source: "25/03/2026",
      readMoreLink: "/blogpost5"
    },
    {
      image: image2,
      category: "Sustainable Farming",
      categoryColor: "#7BC216",
      title: "The Rise of Renewable Energy in Africa",
      description: "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...",
      source: "05/02/2026",
      readMoreLink: "/blogpost3"
    },
    {
      image: image3,
      category: "Clean Transport",
      categoryColor: "#006633",
      title: "2026 Climate Mobility Horizon: Nigeria’s New Income Engine – Netzence",
      description: "Nigeria is facing a potential silent public-health emergency – one that does not announce itself with sirens or breaking news...",
      source: "06/01/2026",
      readMoreLink: "/blogpost4"
    },
    // Row 2
    {
      image: image4,
      category: "Global Footprint Network",
      categoryColor: "#00AED9",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      readMoreLink: "/blogpost2"
    },
    {
      image: spotlight,
      category: "Clean Transport",
      categoryColor: "#006633",
      title: "Introducing Low-cost mobility for Nigeria’s transport system – Netzence",
      description: "Nigeria’s mobility ecosystem is undergoing a profound shift. Rising fuel prices, worsening congestion, and growing urban populations ",
      source: "28/12/2025",
      readMoreLink: "/blogpost1"
    },
    {
      image: image6,
      category: "Carbon Credit",
      categoryColor: "#141414",
      title: "Turning Lagos forests into climate revenue asset – Netzence",
      description: "In a bid to increase revenue for the country, Netzence sustainability Limited has said that baseline studies and carbon credits ",
      source: "18/09/2026",
      readMoreLink: "/blogpost6"
    },
    // Row 3
    {
      image: imgage7,
      category: "Global Footprint Network",
      categoryColor: "#00AED9",
      title: "The United Nations welcomes Netzence Sustainability Limited into the United Nations Global Compact.",
      description: "Netzence Sustainability Limited is proud to announce its official acceptance as a participant in the United Nations Global Compact...",
      source: "18/07/2025",
      readMoreLink: "/blogpost7"
    },
    {
      image: image8,
      category: "Climate change",
      categoryColor: "#012657",
      title: "Nigeria can turn climate crisis into $9bn opportunity – Netzence",
      description: "Netzence Sustainability Limited (Netzence) has said Nigeria can transform its social challenges into economic resilience by tapping into its CloseCarbon, a real-time carbon..",
      source: "03/07/2025",
      readMoreLink: "/blogpost8"
    },
    {
      image: imgage9,
      category: "Carbon credit",
      categoryColor: "#141414",
      title: "Netzence, Axxela partner to drive Nigeria’s carbon credit economy",
      description: "Nigeria’s foremost green technology innovator, Netzence Sustainability Limited, has concluded plans to harmonise economic growth with environmental stewardship at a time",
      source: "26/06/2025",
      readMoreLink: "/blogpost9"
    }
  ];

  // Split articles into rows of 3
  const rows = [];
  for (let i = 0; i < articles.length; i += 3) {
    rows.push(articles.slice(i, i + 3));
  }

  return (

    <div className="flex flex-col items-start p-0 gap-8 w-full max-w-[1200px] mx-auto">
      {rows.map((row, rowIndex) => (
        <div 
          key={rowIndex}
          className="flex flex-row items-center p-0 gap-8 w-full"
        >
          {row.map((article, colIndex) => (
            <ArticleCard key={colIndex} {...article} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default BlogGrid;